import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Timeline, {
  TimelineHeaders,
  DateHeader,
  SidebarHeader,
} from 'react-calendar-timeline'
import 'react-calendar-timeline/style.css'
import dayjs from 'dayjs'


// Services
import LocalStorageService from '../services/LocalStorageService';
import TimetableService from '../services/TimetableService';

// Grommet
import { ResponsiveContext, ThemeContext } from 'grommet'

// Appt Components
import Anchor from '../components/simple/anchor/Anchor';
import Box from '../components/simple/box/Box';

// Appt Widgets
import moment from 'moment';
import BreadcrumbBar from './shared/BreadcrumbBar';
import ActionButton from '../components/compound/actionButton/ActionButton';
import H2 from '../components/simple/heading/H2';
import DateInput from '../components/simple/input/DateInput';


import { FEATURE_TIMETABLE_ENABLED } from '../env.js'
import Text from '../components/simple/text/Text.js';


function Timetable(props) {

  const navigate = useNavigate()
  const params = useParams();


  const [timetable, setTimetable] = useState(null);
  const [hasTimetable, setHasTimetable] = useState(false);

  const [currentDate, setCurrentDate] = useState(params?.date ? new Date(params?.date) : new Date());

  const getTimetableForDay = async (date) => {
    const apiToken = LocalStorageService.get('apiToken');
    const timetable = await TimetableService.getTimetableForDay(apiToken, date);
    return timetable;
  }

  const onItemClick = (itemId) => {
    let foundItem = items.find(i => Number.parseInt(i.id) === Number.parseInt(itemId));
    if (!foundItem) {
      return;
    }
    void navigate(`/class/${foundItem.id}`);
  }

  const getTimetableData = async (date) => {
    const data = await getTimetableForDay(date);
    if (data) {
      setTimetable(data?.classes);
      setHasTimetable(!!data?.classes?.length);
    }
  }
  useEffect(() => {
    void getTimetableData(currentDate);
  }, [currentDate]);

  useEffect(() => {
    if (FEATURE_TIMETABLE_ENABLED !== 'true') {
      void navigate('/');
    }
  }, []);


  const [groups, setGroups] = useState([]);
  const [items, setItems] = useState([]);


  useEffect(() => {
    if (!timetable) return;

    let yearGroups = timetable.map(item => item.yearGroup);
    const stripYear = (yearGroup) => Number.parseInt(yearGroup.replaceAll('Year', ''));
    yearGroups = [...new Set(yearGroups)].sort((a, b) => stripYear(a) - stripYear(b)).map((yearGroup, index) => ({ id: index + 1, title: yearGroup }));

    setGroups(yearGroups);

    let events = timetable.map(item => ({
      id: item.id,
      group: yearGroups.find(y => y.title === item.yearGroup)?.id,
      title: item.lesson,
      start_time: dayjs(item.startTime),
      end_time: dayjs(item.endTime)
    }));

    setItems(events);
  }, [timetable, currentDate]);


  const dayStart = dayjs(currentDate).hour(8).valueOf();
  const dayEnd = dayjs(currentDate).hour(17).valueOf();


  return (
     <ResponsiveContext.Consumer>
      {(size) => {
        return (
      <>
        <BreadcrumbBar
              title="Timetable"
          path={<> <Anchor href="/">BehaviourSmart</Anchor></>}
        />

        <Box
              background="white"
              round="small"
              width="xlarge"
              height="large"
        >

              <Box margin={{ vertical: 'small', horizontal: 'medium' }} direction="row" align="center" gap="small" justify="between">
                <ActionButton label="< Back" onClick={() => setCurrentDate(dayjs(currentDate).add(-1, 'day').toDate())} />
                <Box direction="row" align="center" gap="small">
                  <H2>{moment(currentDate).format('ddd, MMM Do YYYY')}</H2>
                  <Box round="xsmall" overflow="hidden" background="white">
                    {/* Timeline items/headers use z-index up to 88; Grommet drops default to 20 */}
                    <ThemeContext.Extend value={{ global: { drop: { zIndex: 100 } } }}>
                      <DateInput
                        value={moment(currentDate).toISOString()}
                        onChange={({ value }) => setCurrentDate(moment(value).toDate())}
                      />
                    </ThemeContext.Extend>
                  </Box>
                </Box>
                <ActionButton label="Next >" onClick={() => setCurrentDate(dayjs(currentDate).add(1, 'day').toDate())} />
              </Box>



              <Box
                fill="horizontal"
                pad="small"
                width='large'
                height='large'
              >
                <Timeline
                  className="bs-timeline"
                  buffer={1}
                  groups={groups}
                  items={items}
                  canMove={false}
                  canResize={false}
                  canChangeGroup={false}
                  canSelectTime={false}
                  canSelectGroup={false}
                  canSelectItem={false}
                  lineHeight={50}
                  sidebarWidth={100}
                  defaultTimeStart={dayjs(currentDate).hour(8).valueOf()}
                  defaultTimeEnd={dayjs(currentDate).hour(17).valueOf()}
                  visibleTimeStart={dayStart}
                  visibleTimeEnd={dayEnd}
                  onItemSelect={(item) => onItemClick(item)}
                  onItemClick={(item) => onItemClick(item)}
                  onTimeChange={(start, end, updateScrollCanvas) => {
                    updateScrollCanvas(dayStart, dayEnd);
                  }}
                >
                  <TimelineHeaders>
                    <SidebarHeader />
                    <DateHeader unit="hour" labelFormat="HH:mm" />
                  </TimelineHeaders>
                </Timeline>
                {!hasTimetable && (
                  <Box margin={{ vertical: 'small', horizontal: 'medium' }} direction="row" align="center" gap="small" justify="center">
                    <Text>No timetable data available for this day.</Text>
                  </Box>
                )}
              </Box>



        </Box>
      </>
    )}}
    </ResponsiveContext.Consumer>
  );
}

export default Timetable;
